/**
 * Writes Meta fbc/fbp into Shopify cart attributes for CAPI attribution.
 * Runs site-wide on every page load (not checkout-only).
 *
 * NOTE: utm_source / full_url / gokwik_cid are written by a separate script
 * that is NOT present in this theme (likely GoKwik or a Shopify Script Tag).
 * This file only adds meta_fbc / meta_fbp via a merge-friendly cart update.
 */
(function () {
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function buildMetaAttributes() {
    let meta_fbc = getCookie('_fbc');
    if (!meta_fbc) {
      const params = new URLSearchParams(window.location.search);
      const fbclid = params.get('fbclid');
      if (fbclid) meta_fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    }
    const meta_fbp = getCookie('_fbp');

    const attributes = {};
    if (meta_fbc) attributes.meta_fbc = meta_fbc;
    if (meta_fbp) attributes.meta_fbp = meta_fbp;
    return attributes;
  }

  function writeCartAttributes(attributes) {
    if (!attributes || !Object.keys(attributes).length) return;

    var payloadKey = JSON.stringify(attributes);
    try {
      if (sessionStorage.getItem('meta_fb_cart_attrs') === payloadKey) return;
    } catch (e) {}

        // Shopify routes.cart_update_url is "/cart/update"; Ajax JSON needs ".js"
    var updateUrl =
      (window.routes && window.routes.cart_update_url) || '/cart/update';
    if (updateUrl.indexOf('.js') === -1) updateUrl += '.js';

    fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (!response.ok) return;
        try {
          sessionStorage.setItem('meta_fb_cart_attrs', payloadKey);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function sync() {
    writeCartAttributes(buildMetaAttributes());
  }

  // Immediate capture (fbclid on landing URL); retry shortly after for Meta Pixel cookies.
  sync();
  setTimeout(sync, 1500);
})();
